












import { Component, Vue, Inject, Prop, Emit, Watch } from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../lib/ajax';
import AbpBase from '../../lib/abpbase';
@Component
export default class SelectPerson extends AbpBase {
	@Prop([String, Number, Array]) value:string | number | Array<any>;
	@Prop({type: Boolean}) multiple:boolean;
	initData:any = {
		personnels: []
	}
    @Emit('input')
    handleChange(value:any) {
    	
    }
    mounted() {
    	// 获取所有人员信息
    	this.$store.dispatch('project/GetAllPersons').then(() => {
    		this.initData.personnels = this.$store.state.project.allPersons;
    	})
    }
}
